/* eslint-disable ember/no-computed-properties-in-native-classes */
import AssessmentController from '../page/assessment';
import { computed } from '@ember/object';

export default class UnlinkedPostsController extends AssessmentController {
  @computed('model.posts.@each.assessment_id')
  get unlinkedPosts() {
    return this.model.posts.filter((item) => !item.assessment_id);
  }
}
